var openPopup = function (container) {
    $(container).click(function () {
        window.open($(this).attr('href'), 't', 'toolbar=0,resizable=1,status=0,width=700,height=600');
        return false;
    });
};

jQuery(document).ready(function($){
    openPopup('.pop');
});
